import { createRoot } from 'react-dom/client'
import React, { lazy, Suspense } from 'react'

import { getPostSessionStore } from '@/ps/stores/post_session_store'
import { MaterialIcon } from '@/core/components/material-icon'

const PostSessionRoot = lazy(() => import('./index'))

export const mountPostSessionReact = () => {
  const post_session_root = document.getElementById('post-session-root')
  const dataScript = document.getElementById('post_session_data')

  if (post_session_root && dataScript) {
    let data
    try {
      data = JSON.parse(dataScript?.textContent || '')
    } catch (ex) {
      throw new Error('failed to parse initial data')
    }
    // Initialize post session store
    getPostSessionStore().initialize(data)

    createRoot(post_session_root).render(
      <Suspense
        fallback={
          <div className="flex justify-center">
            <MaterialIcon
              icon={'progress_activity'}
              className="text-primary animate-spin"
              size={48}
            />
          </div>
        }
      >
        <PostSessionRoot />
      </Suspense>,
    )
  }
}
